import { getContext } from 'svelte';
import { tileObserver } from './TileObserver.browser.ts';

export type TileObservation = Pick<typeof tileObserver, 'observeBeforeEnter' | 'observeOnEnter'>;

export const TILE_OBSERVER_KEY: unique symbol = Symbol('TileObserver');

export function useTileObserver(): TileObservation {
    return getContext<TileObservation>(TILE_OBSERVER_KEY) ?? tileObserver;
}
